
namespace Matrix {

    export interface CodeEditorOptions {
        mode?: string;
        mimeType?: string;
        cols?: number;
        rows?: number;
    }

    export function loadJS(check: any, url: string, then: () => void, nope?: () => void) {
        if (check && check !== "undefined") {
            then();
            return;
        }

        url = Q.resolveUrl(url);
        var script = document.querySelector('script[src="' + url + '"]') as HTMLScriptElement;
        if (script) {
            script.addEventListener("load", then);
            return;
        }

        nope && nope();
        script = document.createElement('script') as HTMLScriptElement;
        then && script.addEventListener("load", then);
        script.src = url;
        document.head.appendChild(script);
    }

    export function loadCSS(url: string, then?: () => void) {

        url = Q.resolveUrl(url);
        var style = document.querySelector('link[href="' + url + '"]') as HTMLLinkElement
        if (style) {
            if (style.sheet) {
                then && then();
                return;
            }

            then && style.addEventListener("load", then);
            return;
        }

        style = document.createElement('link') as HTMLLinkElement;
        style.rel = "stylesheet";
        then && style.addEventListener("load", then);
        style.href = url;
        document.head.appendChild(style);
    }

    @Serenity.Decorators.element("<div><textarea></textarea></div>")
    @Serenity.Decorators.registerEditor([Serenity.IStringValue, Serenity.IReadOnly])
    export class CodeEditor extends Serenity.Widget<CodeEditorOptions>
        implements Serenity.IStringValue, Serenity.IReadOnly {

        private editor: CodeMirror.EditorFromTextArea;
        private textarea: JQuery;
        private _initialValue: string;

        constructor(element: JQuery, options: CodeEditorOptions) {
            super(element, options);

            this.textarea = element.children()

            if (options.rows)
                this.textarea.attr('rows', options.rows);

            if (options.cols)
                this.textarea.attr('cols', options.cols);

            CodeEditor.loadCodeMirror(this.options.mode, () => {
                Serenity.LazyLoadHelper.executeOnceWhenShown(this.textarea, () => {
                    this.editor = CodeMirror.fromTextArea(this.textarea[0] as HTMLTextAreaElement, {
                        readOnly: this.get_readOnly(),
                        mode: this.options.mimeType,
                        theme: 'cobalt'
                    });
                    this.element.triggerHandler('editorinit');
                    if (this.currentLang) {
                        var languageInfo = this.supportedLangs[this.currentLang];
                        loadJS(typeof CodeMirror['modes'][languageInfo.type], "~/Scripts/codemirror/mode/" + languageInfo.type + ".js", () => {
                            this.editor.setOption("mode", languageInfo.mime);
                        });
                    }
                });
            });
        }

        protected supportedLangs = {
            "csharp": {
                type: "clike",
                mime: "text/x-csharp"
            },
            "javascript": {
                type: "javascript",
                mime: "text/javascript"
            },
            "typescript": {
                type: "javascript",
                mime: "text/typescript"
            },
            "ecmascript": {
                type: "javascript",
                mime: "text/ecmascript"
            },
            "sql": {
                type: "sql",
                mime: "text/x-mssql"
            }            
        };

        protected currentLang: string;

        public setLanguage(lang: string) {
            if (!lang || !this.supportedLangs[lang])
                return;
            
            if (!this.editor) {
                this.currentLang = lang;
                return;
            }

            if (this.currentLang != lang) {
                var languageInfo = this.supportedLangs[lang];
                CodeEditor.loadCodeMirror(languageInfo.type, () => {
                    this.editor.setOption("mode", languageInfo.mime);
                });
                this.currentLang = lang;
            }
        }

        destroy() {
            if (this.editor != null) {
                this.editor.toTextArea();
                this.editor = null;
            }
            super.destroy();
        }

        static loadCodeMirror(mode: string, then: () => void) {
            loadJS(typeof CodeMirror, "~/Scripts/codemirror/codemirror.js", () => {
                if (mode)
                    loadJS(typeof CodeMirror['modes'][mode], "~/Scripts/codemirror/mode/" + mode + ".js", then);
                else
                    then();
            }, () => {
                loadCSS("~/Scripts/codemirror/codemirror.css");
            });
        }

        public get_value() {
            this.editor && this.editor.save();
            return this.textarea.val();
        }

        public set_value(value: string) {
            if (value == null)
                value = "";
            this.editor ? this.editor.setValue(value) : this.textarea.val(value);
        }

        public get_readOnly() {
            return this.textarea.is('[readonly]');
        }

        public set_readOnly(value: boolean) {
            if (!value !== !this.get_readOnly()) {
                this.element.toggleClass('readonly', !!value);
                if (value)
                    this.textarea.attr('readonly', 'readonly');
                else
                    this.textarea.removeAttr('readonly');
                this.editor && this.editor.setOption('readOnly', !!value);
            }
        }
    }
}
